<template>
  <div class="current-date">
    <img class="current-date__icon" src="@/assets/images/RU/calendar-icon.png" alt="" />
    <span class="current-date__text">{{ currentDate }}</span>
  </div>
</template>

<script>
function formatDate(date) {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = String(date.getFullYear()).slice(-2);
  return `${day}.${month}.${year}`;
}

export default {
  name: 'CurrentDate',
  computed: {
    currentDate() {
      const { updated } = this.$store.state;
      return formatDate(updated || new Date());
    },
  },
};
</script>

<style scoped>
.current-date {
  position: absolute;
  top: 20px;
  left: 1082px;
  display: flex;
  align-items: center;
  padding-left: 36px;
  background: rgba(255, 255, 255, 0.04);
  backdrop-filter: blur(30px);
  -webkit-backdrop-filter: blur(16px);

  width: 196px;
  height: 80px;
  opacity: 1;
  gap: 12px;
  border-radius: 16px;
}

.current-date__icon {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
}

.current-date__text {
  font-family: 'ONY One', serif;
  font-weight: 500;
  font-size: 28px;
  line-height: 100%;
  color: #FFFFFF;
  white-space: nowrap;
}
</style>
